import React from "react";
import { GoPlus } from "react-icons/go";

const Add = ({ addClickEvent, extraClasses }) => {
  return (
    <div>
      <button
        onClick={addClickEvent}
        className={`rounded-full bg-[#FF6943] h-10 w-10 flex justify-center items-center text-center ${extraClasses}`}
      >
        <GoPlus size={20} className="font-bold text-white " />
      </button>
    </div>
  );
};

export default Add;
